<template>
    <div class="modal fade" id="builder_modal" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
            <div class="modal-content KpiBoxes">
                <div class="modal-header padding-x15 padding-y10">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body">
                    <div class="row">
                        <div class="col-4 select-element-name">
                            <h6>Name your element</h6>
                            <div>
                                <input v-model="name" type="text" class="form-control">
                                <div class="invalid-feedback">Element with name {{ name }} already exists.</div>
                            </div>
                        </div>
                    </div>

                    <hr>

                    <div class="row margin-top20">
                        <div class="col-4 select-data-source">
                            <h6>Select data source</h6>
                            <v-select :clearable="false" v-model="selected_data_source" :reduce="data_source => data_source.id" label="name" :options="$store.getters.getBuilderPopupParams.data_sources"></v-select>
                        </div>
                    </div>

                    <div class="row margin-top20">
                        <h6 class="col-12">Select metrics</h6>

                        <div class="col-4">
                            <div class="metrics-list-selections">
                                <input v-model="search_metric" placeholder="Search for a metric..." type="search" class="form-control">

                                <hr class="margin-x0 margin-y10">

                                <div>
                                    <ul class="list-group">
                                        <li v-if="getMetrics.length === 0" class="list-group-item padding-x10 padding-y5">No metrics found.</li>
                                        <li v-for="metric in getMetrics" @click="selectMetric(metric.id, $event)" class="list-group-item padding-x10 padding-y5" :class="{ 'active': metric.selected, 'hidden': metric.applied === true }" :title="metric.metric_name">{{ metric.new_metric_name || metric.metric_name }}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div class="col-1 align-self-center padding-x5">
                            <button @click="applySelectedMetrics" class="btn btn-info">Apply</button>
                        </div>

                        <div class="col-5">
                            <div class="metrics-list-selected">
                                <h6 class="selected-metrics-title">Selected metrics ({{ selected_metrics.length }} of {{ element.max_metrics_visible || 'TBD' }})</h6>

                                <hr class="margin-x0 margin-y10">

                                <div>
                                    <ul class="list-group">
                                        <draggable v-model="selected_metrics" :disabled="metric_sort_disabled" @start="drag=true" @end="drag=false">
                                            <li v-if="selected_metrics.length === 0" class="list-group-item padding-x10 padding-y5">No metrics selected.</li>

                                            <li v-else v-for="metric in selected_metrics" class="list-group-item padding-x10 padding-y5">
                                                <span v-if="!metric.is_editing">
                                                    <span class="metric-name">{{ metric.new_metric_name || metric.metric_name }}</span>
                                                    <i v-if="metric.new_metric_name" class="fa fa-info-circle text-secondary margin-left5" aria-hidden="true" :title="metric.metric_name"></i>
                                                </span>
                                                <input v-else @keyup.enter="saveAppliedMetricName(metric.id, $event)" type="text" class="form-control metric-edit" :value="metric.new_metric_name || metric.metric_name">
                                                <i v-if="!metric.is_editing" @click="removeAppliedMetric(metric.id)" class="fa fa-times pull-right text-danger margin-left10" aria-hidden="true"></i>
                                                <i v-if="!metric.is_editing" @click="editAppliedMetricName(metric.id, $event)" class="fa fa-pencil pull-right text-info margin-left10" aria-hidden="true"></i>
                                                <i v-if="metric.is_editing" @click="cancelAppliedMetricName(metric.id, $event)" class="fa fa-times pull-right text-danger margin-left10" aria-hidden="true"></i>
                                                <i v-if="metric.is_editing" @click="saveAppliedMetricName(metric.id, $event)" class="fa fa-check pull-right text-success margin-left10" aria-hidden="true"></i>
                                                <i class="fa fa-sort pull-right margin-left10" aria-hidden="true"></i>
                                                <span class="pull-right">({{ metric.data_source_abbr }})</span>
                                            </li>
                                        </draggable>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <hr>

                    <div class="row">
                        <div class="col-12">
                            <template v-for="config in element.element_configurations">
                                <div class="margin-bottom10" :class="checkIndexes(config)">
                                    <template v-if="config.config_selector_type === 'checkbox'">
                                        <label>
                                            <p-input v-model="configurations[config.config_id]" @change="changeConfig(config, $event)" class="p-default p-curve single" type="checkbox" :value="config.config_id"> {{ config.config_name }}</p-input>
                                        </label>
                                    </template>

                                    <template v-if="config.config_selector_type === 'selectbox'">
                                        <h6>{{ config.config_name }}</h6>
                                        <div class="col-3 px-0">
                                            <v-select :clearable="false" :value="configurations[config.config_id] || config.config_values[0]" @input="changeConfig(config, $event)" label="name" :options="config.config_values"></v-select>
                                        </div>
                                    </template>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>

                <div class="modal-footer padding-y10">
                    <button :disabled="build_disabled" @click="buildElement" type="button" class="btn btn-success">{{ edit_mode ? 'Update' : 'Build' }} Element</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        created() {
            this.selected_data_source = this.$store.getters.getBuilderPopupParams.data_sources[0].id;
            this.element              = this.$store.getters.getBuilderPopupParams.element;
            this.edit_mode            = this.$store.getters.getBuilderPopupParams.edit_mode || false;
            this.has_indexes          = this.$store.getters.getBuilderPopupParams.has_indexes;
            _.each(this.element.element_configurations, (config) => {
                if(!this.configurations[config.config_id]){
                    this.configurations[config.config_id] = config.config_values[0];
                }
            });
            Object.assign(this.$data, vm.customClone(this.$store.getters.getBuilderPopupParams.data || {}));
            if(this.selected_metrics.length){
                this.selected_data_source = this.selected_metrics[0].data_source_id;
            }
            this.validate();
        },

        mounted(){
            _.each(this.element.element_configurations, (config) => {
                if(config.config_short_name == 'show_index_values'){
                    this.index_is_checked = this.configurations[config.config_id];
                }
            });
        },
        data() {
            return {
                name:                 '',
                original_name:        '',
                selected_data_source: '',
                search_metric:        '',
                element:              {},
                metrics:              [],
                selected_metrics:     [],
                configurations:       {},
                build_disabled:       true,
                edit_mode:            false,
                metric_sort_disabled: false,
                has_indexes:          false,
                index_is_checked:     false
            }
        },

        methods: {
            selectMetric(metricId, event) {
                const index = _.findIndex(this.metrics, {id: metricId});

                this.metrics[index].selected = !$(event.target).hasClass('active');
            },

            applySelectedMetrics() {
                if ((this.selected_metrics.length + _.filter(this.metrics, {selected: true}).length) > this.element.max_metrics_visible) {
                    this.$notify({
                        type: 'error',
                        text: `The maximum metrics for this is ${this.element.max_metrics_visible}. Please remove one of the current metrics if you want to add a replacement.`
                    });

                    return false;
                }

                _.each(this.metrics, metric => {
                    if (metric.selected && _.findIndex(this.selected_metrics, {id: metric.id}) === -1) {
                        metric.applied  = true;
                        metric.selected = false;

                        this.selected_metrics.push(metric);
                    }
                });

                this.validate();
            },

            editAppliedMetricName(metricId, event) {
                let index = _.findIndex(this.selected_metrics, {id: metricId});

                if (index > -1) {
                    this.selected_metrics[index].is_editing = true;
                }

                this.metric_sort_disabled = true;

                this.$forceUpdate();
                this.$nextTick(() => {
                    $(event.target).closest('li').find('.metric-edit').select();
                });
            },

            cancelAppliedMetricName(metricId, event) {
                let index = _.findIndex(this.selected_metrics, {id: metricId});

                if (index > -1) {
                    this.selected_metrics[index].is_editing = false;
                }

                this.metric_sort_disabled = false;

                this.$forceUpdate();
                this.$nextTick(() => {
                    $(event.target).closest('li').find('.metric-edit').select();
                });
            },

            saveAppliedMetricName(metricId, event) {
                let index = _.findIndex(this.selected_metrics, {id: metricId});

                if (index > -1) {
                    this.selected_metrics[index].is_editing      = false;
                    this.selected_metrics[index].new_metric_name = $(event.target).closest('li').find('.metric-edit').val().trim();

                    let formData = new FormData;
                    formData.append('metric_id', this.selected_metrics[index].metric_id);
                    formData.append('new_metric_name', this.selected_metrics[index].new_metric_name);
                    formData.append('_method', 'PUT');

                    if (this.selected_metrics[index].client_x_metric_x_data_source_id) {
                        formData.append('client_x_metric_x_data_source_id', this.selected_metrics[index].client_x_metric_x_data_source_id);
                    } else {
                        formData.append('data_source_ids', JSON.stringify([this.selected_metrics[index].data_source_id]));
                    }

                    this.ajaxSubmit({}, 'POST', `/api/metrics/client/${this.$store.getters.getBuilderPopupParams.client_id}/glossary`, formData).then(response => {
                        const queryString = $.param({
                            data_source_id: this.selected_data_source,
                            client_id:      this.$store.getters.getBuilderPopupParams.client_id,
                            element_id:     this.element.id
                        });

                        axios.get(`/api/metrics?${queryString}`).then(metrics => {
                            let renamedMetrics = _.filter(metrics.data, metric => {
                                return metric.client_x_metric_x_data_source_id !== null;
                            });

                            _.each(renamedMetrics, metric => {
                                let renamedMetricIndex = _.findIndex(this.metrics_1, {id: metric.id});

                                if (renamedMetricIndex > -1) {
                                    this.metrics_1[renamedMetricIndex].new_metric_name                  = metric.new_metric_name;
                                    this.metrics_1[renamedMetricIndex].client_x_metric_x_data_source_id = metric.client_x_metric_x_data_source_id;
                                }

                                renamedMetricIndex = _.findIndex(this.selected_metrics_1, {id: metric.id});

                                if (renamedMetricIndex > -1) {
                                    this.selected_metrics_1[renamedMetricIndex].new_metric_name                  = metric.new_metric_name;
                                    this.selected_metrics_1[renamedMetricIndex].client_x_metric_x_data_source_id = metric.client_x_metric_x_data_source_id;
                                }
                            });
                        });
                    });
                }

                this.metric_sort_disabled = false;

                this.$forceUpdate();
            },

            removeAppliedMetric(metricId) {
                let index = _.findIndex(this.selected_metrics, {id: metricId});
                this.selected_metrics.splice(index, 1);

                index = _.findIndex(this.metrics, {id: metricId});
                if (index > -1) {
                    this.metrics[index].applied = false;
                }

                this.validate();
            },

            buildElement() {
                if (!this.edit_mode) {
                    this.$store.commit('addBuilderElement', {
                        name:                 this.name || this.$parent.generateElementName(),
                        element_id:           this.element.id,
                        element_abbreviation: this.element.abbreviation,
                        metrics:              this.selected_metrics,
                        configurations:       this.configurations
                    });
                } else {
                    this.$store.commit('updateBuilderElement', {
                        data: {
                            name:                 this.name || this.$parent.generateElementName(),
                            element_id:           this.element.id,
                            element_abbreviation: this.element.abbreviation,
                            metrics:              this.selected_metrics,
                            configurations:       this.configurations
                        },

                        name: this.$store.getters.getBuilderPopupParams.data.original_name
                    });
                }

                event_bus.$emit('element_saved', true);

                $('#builder_modal').modal('hide');
            },

            changeConfig(config, value) {
                if(config.config_short_name == 'show_index_values'){
                    this.index_is_checked = value;
                }
                const configId = config.config_id;
                if (typeof value === 'boolean') {
                    if (value === true) {
                        this.configurations[configId] = 'true';
                    } else {
                        delete this.configurations[configId];
                    }
                } else {
                    this.configurations[configId] = value;
                }

                this.$forceUpdate();
            },

            validate() {
                this.build_disabled = true;

                if (
                    (
                        _.findIndex(this.$store.getters.getBuilderElements, {name: this.name}) === -1
                        || (this.edit_mode && this.$store.getters.getBuilderPopupParams.data.name === this.name)
                    )
                    && this.element.max_metrics_visible >= this.selected_metrics.length
                    && this.element.min_metrics_visible <= this.selected_metrics.length
                ) {
                    this.build_disabled = false;
                }
            },
            checkIndexes(config){
                if((config.config_short_name == 'show_index_values') && (!this.has_indexes)){
                    return 'hidden';
                }
                if((config.config_short_name == 'select_index_name') && (!this.index_is_checked)){
                    return 'hidden';
                }
            }
        },

        watch: {
            selected_data_source() {
                if (this.selected_data_source) {
                    const queryString = $.param({
                        data_source_id: this.selected_data_source,
                        client_id:      this.$store.getters.getBuilderPopupParams.client_id,
                        element_id:     this.element.id
                    });

                    axios.get(`/api/metrics?${queryString}`).then(metrics => {
                        _.each(metrics.data, metric => {
                            metric.selected = false;
                            metric.applied  = _.findIndex(this.selected_metrics, {id: metric.id}) > -1;
                        });

                        this.metrics = metrics.data;
                    });
                }
            },

            name() {
                if (this.name) {
                    if (
                        _.findIndex(this.$store.getters.getBuilderElements, {name: this.name}) === -1
                        || (this.edit_mode && this.$store.getters.getBuilderPopupParams.data.name === this.name)
                    ) {
                        $('#builder_modal').find('.select-element-name input').removeClass('is-invalid');
                    } else {
                        $('#builder_modal').find('.select-element-name input').addClass('is-invalid');
                    }
                }

                this.validate();
            }
        },

        computed: {
            getMetrics() {
                return this.metrics.filter(metric => {
                    let metricName = metric.new_metric_name || metric.metric_name;

                    return metricName.toLowerCase().indexOf(this.search_metric.toLowerCase()) > -1;
                });
            }
        }
    }
</script>
